import { render, staticRenderFns } from "./MyCoursesTiles.vue?vue&type=template&id=748a598b&scoped=true&"
import script from "./MyCoursesTiles.vue?vue&type=script&lang=js&"
export * from "./MyCoursesTiles.vue?vue&type=script&lang=js&"
import style0 from "./MyCoursesTiles.vue?vue&type=style&index=0&id=748a598b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a598b",
  null
  
)

export default component.exports